import React from 'react';
import { Icon } from '.';

export const IconLaptop = props => {
  return (
    <Icon
      color="GREEN"
      {...props}
      aria-label="A chat bubble with dots, usually indicates feedback."
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="GREEN"
          fillRule="nonzero"
          stroke="none"
          d="M 16.80,15.60
           C 17.46,15.60 17.99,15.06 17.99,14.40
             17.99,14.40 18.00,7.80 18.00,7.80
             18.00,7.14 17.46,6.60 16.80,6.60
             16.80,6.60 7.20,6.60 7.20,6.60
             6.54,6.60 6.00,7.14 6.00,7.80
             6.00,7.80 6.00,14.40 6.00,14.40
             6.00,15.06 6.54,15.60 7.20,15.60
             7.20,15.60 4.80,15.60 4.80,15.60
             4.80,16.26 5.34,16.80 6.00,16.80
             6.00,16.80 18.00,16.80 18.00,16.80
             18.66,16.80 19.20,16.26 19.20,15.60
             19.20,15.60 16.80,15.60 16.80,15.60
             16.80,15.60 16.80,15.60 16.80,15.60 Z
           M 7.20,7.80
           C 7.20,7.80 16.80,7.80 16.80,7.80
             16.80,7.80 16.80,14.40 16.80,14.40
             16.80,14.40 7.20,14.40 7.20,14.40
             7.20,14.40 7.20,7.80 7.20,7.80
             7.20,7.80 7.20,7.80 7.20,7.80 Z
           M 12.00,16.20
           C 11.67,16.20 11.40,15.93 11.40,15.60
             11.40,15.27 11.67,15.00 12.00,15.00
             12.33,15.00 12.60,15.27 12.60,15.60
             12.60,15.93 12.33,16.20 12.00,16.20
             12.00,16.20 12.00,16.20 12.00,16.20 Z
           M 24.00,12.00
           C 24.00,18.63 18.63,24.00 12.00,24.00
             5.37,24.00 0.00,18.63 0.00,12.00
             0.00,5.37 5.37,0.00 12.00,0.00
             18.63,0.00 24.00,5.37 24.00,12.00 Z"
        />
      </svg>
    </Icon>
  );
};
